import React, {useEffect, useState} from 'react';
import Form from 'react-bootstrap/Form';
import { useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { getPreviewCard, savePreviewCard } from '../services/PreviewCards';


export default function PreviewCardEdit() {
  const domain = useSelector(state => state.app.current_domain);
  const history = useHistory();
  const {card_id} = useParams();
  const cardID = card_id === "new" ? "" : card_id;
  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [image_url, setImageUrl] = useState("");

  useEffect(() => {
    setName("");
    setTitle("");
    setDescription("");
    setImageUrl("");
    if (!cardID || !domain) {
      return;
    }
    getPreviewCard(domain, cardID).then((card) => {
      setName(card.name || "");
      setTitle(card.title || "");
      setDescription(card.description || "");
      if (card.image_url) {
        setImageUrl(card.image_url + "?c=" + Date.now());
      }
    });
  }, [cardID, domain]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!name) {
      alert("You must provide a name for the preview card");
      return;
    }
    if (!title && !description) {
      alert("You must provide a title or description");
      return;
    }
    savePreviewCard(e.currentTarget).then(() => history.push("/preview_cards"));
  }

  return (
    <div className="container px-0" id="message_edit">
        <div className="row">
          <div className="col-12">
              <br/>
            <h3>{name || 'Create/Edit Link Preview'}</h3>
          </div>
          <div className="row">
            <div className="col-12">
                <p>Edit/create your preview card for this domain.</p>
            </div>
          </div>
          <div className="col-12">
          <Form onSubmit={onSubmit}>
            <input type="hidden" name="domain" value={domain}/>
            <input type="hidden" name="id" value={cardID}/>
            { cardID ? (
                <input type="hidden" name="name" value={name}/>
            ): (
            <Form.Group className="col-sm-6 mb-3">
                <Form.Label >Name: </Form.Label>
                <Form.Control type="input" name="name" value={name} onChange={e => setName(e.target.value)}/>
                <div className="form-text"><em>Note: only Title, Description, and Image fields below will display in Link Preview</em></div>
            </Form.Group>
            )}
            <Form.Group className="col-sm-6 mb-3">
                <Form.Label >Title: </Form.Label>
                <Form.Control type="input" name="title" value={title} onChange={e => setTitle(e.target.value)}/>
            </Form.Group>
            <Form.Group className="col-sm-6 mb-3">
                <Form.Label >Description: </Form.Label><br/>
                <Form.Control as="textarea" rows={4} cols={30} name="description" value={description} onChange={e => setDescription(e.target.value)}/>
            </Form.Group>
            <Form.Group className="col-sm-6 mb-3">
                <Form.Label >Image: </Form.Label><br/>
                { image_url && (
                    <><img src={image_url} alt="preview card"/><br/></>
                )}
                <Form.Control type="file" name="image" accept="image/png, image/jpeg, image/gif, image/jpg"/>
                <div className="form-text">Pro Tip: for best results, use image size 1200x630 pixels</div>
            </Form.Group>
            <button type="submit" className="btn btn-primary">Save</button>
          </Form>
          </div>
        </div>
    </div>
  );
}
